import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkbox-radio',
  templateUrl: './checkbox-radio.component.html',
})
export class CheckboxRadioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
